export const slidesArr = [
  {
    id: 1,
    title: 'Planetscape',
    img: 'https://w.forfun.com/fetch/78/7822e891c6180dd5ddd19bf659c7aa67.jpeg'
  },
  {
    id: 2,
    title: 'Earth from space',
    img: 'https://i.pinimg.com/originals/54/da/d5/54dad576e569ccf74f620de530b9fc87.jpg'
  },
  {
    id: 3,
    title: 'Milky Way from Earth',
    img: 'https://amazingsky.files.wordpress.com/2013/05/summer-milky-way-rising-over-field-may-6-2013-14mm-5dii.jpg'
  },
  {
    id: 4,
    title: 'Mars',
    img: 'https://w.forfun.com/fetch/0f/0f11030a9480f14d2574d650c694306d.jpeg'
  },
];
